<div class="mobile-home-container position-relative h-100">
    <div class="home-image h-100">
        <img src="../../../assets/city-hall-home.png" class="w-100 h-100" alt="">
    </div>
    <div class="logo-image d-flex justify-content-center position-absolute w-100 h-100">
        <img src="../../../assets/logo.png" class="position-absolute" alt="">
        <div *ngIf="isLoading" class="position-absolute loader">
            <ng-lottie width="100%" [options]="options"></ng-lottie>
        </div>
        <div class="continue-action">
            <button [@displayState]="display" *ngIf="!isLoading" [ngClass]="{'continue-english-animation': display}"
                class="continue-btn continue-english-animation text-white fs-7 border-0 font-weight-normal position-absolute"
                [appNavigate]="['welcome']">Continue in English</button>
            <button [@displayState]="display" *ngIf="!isLoading" [ngClass]="{'continue-spanish-animation': display}"
                class="continue-btn continue-spanish-animation text-white fs-7 border-0 font-weight-normal position-absolute"
                [appNavigate]="['es','welcome']">Continuar en Español</button>
        </div>
    </div>
</div>


<div class="desktop-home-container h-100">
    <div class="home-image h-100 d-flex justify-content-center overflow-hidden position-relative">
        <div class="banner-bg position-relative">
            <div class="img-box position-relative">
                <img src="../../../assets/City-Hall-desktopNew.png" class="position-absolute" alt="">
            </div>
        </div>
    </div>
    <div class="logo-image d-flex justify-content-center position-absolute w-100 h-100">

        <img src="../../../assets/logo.png" class="position-absolute" alt="">
        <div *ngIf="isLoading" class="position-absolute loader ">
            <ng-lottie width="100%" [options]="options"></ng-lottie>
        </div>
        <div class="continue-action">
            <button [@displayState]="display" *ngIf="!isLoading" [ngClass]="{'continue-english-animation': display}"
                class="continue-btn continue-english-animation text-white fs-7 border-0 font-weight-normal position-absolute"
                [appNavigate]="['welcome']">Continue in English</button>
            <button [@displayState]="display" *ngIf="!isLoading" [ngClass]="{'continue-spanish-animation': display}"
                class="continue-btn continue-spanish-animation text-white fs-7 border-0 font-weight-normal position-absolute"
                [appNavigate]="['es','welcome']">Continuar en Español</button>
            <!-- <button  class="continue-btn d-block continue-english text-white fs-7 border-0 font-weight-normal" [routerLink]="['welcome']">Continue in English</button>
            <button class="continue-btn d-block continue-spanish text-white fs-7 border-0 font-weight-normal" [routerLink]="['es','welcome']">Continuar en EspaÑol</button> -->
        </div>
    </div>
</div>